export default function AboutUs () {
    return (
        <div className="postContainer">
        <div className="post">
        <h1>About us</h1>
        <p>We're a small group of online sellers and deal hunters who like a good deal and hate a fake one. A lot of "sales" are prices that went up last week and came back down, so we check every product against its 90-day average before we post it.</p>
        <p>Only the deals we'd actually tell a friend about make it onto the site.</p>
        <p>Right now that's Amazon only. If we find a good way to do the same for other stores, we'll add them.</p>
        </div>
    </div>
    );
  };
